import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Partner {
  id: number;
  name: string;
  type: string;
  logo: string;
  alt: string;
  research: string;
  impact: string;
}

const mockPartners: Partner[] = [
{
  id: 1,
  name: 'Stanford Peace Innovation Lab',
  type: 'Research Institution',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1eb79556e-1767072446865.png",
  alt: 'Modern university building with glass facade and students walking on campus',
  research: 'Forgiveness Psychology & Conflict Resolution',
  impact: '12 peer-reviewed studies published'
},
{
  id: 2,
  name: 'Oxford Centre for Compassion',
  type: 'Academic Partner',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1865bc8b2-1768408882496.png",
  alt: 'Historic university library interior with wooden shelves and reading tables',
  research: 'Neuroscience of Forgiveness',
  impact: 'Longitudinal study: 5,000 participants'
},
{
  id: 3,
  name: 'MIT Media Lab',
  type: 'Technology Research',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_14dca18af-1766046647227.png",
  alt: 'Modern tech laboratory with computer screens showing data visualizations',
  research: 'Digital Peace-Building Platforms',
  impact: 'AI-powered conflict prediction models'
},
{
  id: 4,
  name: 'University of Cape Town',
  type: 'Social Science',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1f566bb31-1768558873378.png",
  alt: 'Diverse group of university students collaborating on research project outdoors',
  research: 'Post-Conflict Community Healing',
  impact: 'Field studies in 23 African nations'
}];


const ResearchPartners = () => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-headline font-bold text-foreground mb-3">
          Academic Research Partnerships
        </h2>
        <p className="text-base font-body text-muted-foreground max-w-3xl mx-auto">
          Evidence-based validation from leading institutions worldwide
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {mockPartners.map((partner) =>
        <div
          key={partner.id}
          className="bg-card rounded-lg shadow-md overflow-hidden border border-border hover:shadow-lg transition-all duration-300">

            <div className="relative h-48 overflow-hidden bg-muted">
              <AppImage
              src={partner.logo}
              alt={partner.alt}
              className="w-full h-full object-cover opacity-80" />

              <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent" />
            </div>

            <div className="p-6 space-y-4">
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="px-3 py-1 bg-primary/10 text-primary text-xs font-body font-semibold rounded-full">
                    {partner.type}
                  </span>
                  <Icon name="AcademicCapIcon" size={20} className="text-primary" />
                </div>
                <h3 className="text-xl font-headline font-bold text-foreground">
                  {partner.name}
                </h3>
              </div>

              <div className="space-y-3">
                <div>
                  <p className="text-xs font-body text-muted-foreground mb-1">Research Focus</p>
                  <p className="text-sm font-body font-semibold text-foreground">
                    {partner.research}
                  </p>
                </div>
                <div>
                  <p className="text-xs font-body text-muted-foreground mb-1">Key Impact</p>
                  <p className="text-sm font-body font-semibold text-success">{partner.impact}</p>
                </div>
              </div>

              <div className="pt-4 border-t border-border">
                <button className="text-sm font-body font-semibold text-primary hover:text-primary/80 transition-colors duration-200 flex items-center space-x-2">
                  <span>View Research Publications</span>
                  <Icon name="ArrowTopRightOnSquareIcon" size={16} />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default ResearchPartners;